import { useKeyboardKeyEvent } from 'flow/editor/hooks/useKeyboardKeyEvent';
import { useContext } from 'react';
import { useDiffMode } from 'flow/editor/hooks/useDiffMode';
import { UserContext } from '~/dashboard/context';
import { diffViewShortcut } from 'flow/editor/hooks/useKeyboardKeyEvent/constants';

/**
 * Invokes the diff mode toggle on the "cmd/ctrl + /" keyboard shortcut,
 * but only when the `enableWorkflowDiff` feature flag is enabled.
 */
export default function Diff() {
  const { featureFlags } = useContext(UserContext);
  const handleDiffMode = useDiffMode();

  useKeyboardKeyEvent({
    enabled: featureFlags.enableWorkflowDiff,
    shortcut: diffViewShortcut,
    callback: handleDiffMode,
  });

  return null;
}
